module.exports = __webpack_public_path__ + "static/media/union.b1bdf838.svg";